<template>
  <!-- 水印组件实现 -->
  <div class="watermark-wrapper">
    <!-- 50个水印分布 -->
    <div class="watermark-item" v-for="i in 150" :key="i"  :style="{
        fontSize: fontSize,
        color: color,
        opacity: opacity,
        transform: `rotate(${rotate}deg)`
      }">
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppWatermark',
  props: {
    text: {
      type: String,
      default: '水印文本'
    },
    fontSize: {
      type: String,
      default: '20px'
    },
    color: {
      type: String,
      default: 'rgba(255, 0, 0, 0.4)'
    },
    rotate: {
      type: Number,
      default: -15
    },
    opacity: {
      type: Number,
      default: 1
    }
  },
  mounted() {
    // console.log('密集水印组件已挂载', this.text);
  }
};
</script>

<style scoped>
.watermark-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 9999;
  overflow: hidden;
}

.watermark-item {
  position: absolute;
  font-size: 20px;
  color: rgba(255, 0, 0, 0.4);
  opacity: 0.4;
  transform: rotate(-15deg);
  white-space: nowrap;
  user-select: none;
  padding: 3px;
}

/* 50个水印分布 */
/* 第1行 */
.watermark-item:nth-child(1) { top: 5%; left: 5%; }
.watermark-item:nth-child(2) { top: 5%; left: 25%; }
.watermark-item:nth-child(3) { top: 5%; left: 45%; }
.watermark-item:nth-child(4) { top: 5%; left: 65%; }
.watermark-item:nth-child(5) { top: 5%; left: 85%; }
/* 第2行 */
.watermark-item:nth-child(6) { top: 15%; left: 15%; }
.watermark-item:nth-child(7) { top: 15%; left: 35%; }
.watermark-item:nth-child(8) { top: 15%; left: 55%; }
.watermark-item:nth-child(9) { top: 15%; left: 75%; }
.watermark-item:nth-child(10) { top: 15%; left: 95%; }
/* 第3行 */
.watermark-item:nth-child(11) { top: 25%; left: 5%; }
.watermark-item:nth-child(12) { top: 25%; left: 25%; }
.watermark-item:nth-child(13) { top: 25%; left: 45%; }
.watermark-item:nth-child(14) { top: 25%; left: 65%; }
.watermark-item:nth-child(15) { top: 25%; left: 85%; }
/* 第4行 */
.watermark-item:nth-child(16) { top: 35%; left: 15%; }
.watermark-item:nth-child(17) { top: 35%; left: 35%; }
.watermark-item:nth-child(18) { top: 35%; left: 55%; }
.watermark-item:nth-child(19) { top: 35%; left: 75%; }
.watermark-item:nth-child(20) { top: 35%; left: 95%; }
/* 第5行 */
.watermark-item:nth-child(21) { top: 45%; left: 5%; }
.watermark-item:nth-child(22) { top: 45%; left: 25%; }
.watermark-item:nth-child(23) { top: 45%; left: 45%; }
.watermark-item:nth-child(24) { top: 45%; left: 65%; }
.watermark-item:nth-child(25) { top: 45%; left: 85%; }
/* 第6行 */
.watermark-item:nth-child(26) { top: 55%; left: 15%; }
.watermark-item:nth-child(27) { top: 55%; left: 35%; }
.watermark-item:nth-child(28) { top: 55%; left: 55%; }
.watermark-item:nth-child(29) { top: 55%; left: 75%; }
.watermark-item:nth-child(30) { top: 55%; left: 95%; }
/* 第7行 */
.watermark-item:nth-child(31) { top: 65%; left: 5%; }
.watermark-item:nth-child(32) { top: 65%; left: 25%; }
.watermark-item:nth-child(33) { top: 65%; left: 45%; }
.watermark-item:nth-child(34) { top: 65%; left: 65%; }
.watermark-item:nth-child(35) { top: 65%; left: 85%; }
/* 第8行 */
.watermark-item:nth-child(36) { top: 75%; left: 15%; }
.watermark-item:nth-child(37) { top: 75%; left: 35%; }
.watermark-item:nth-child(38) { top: 75%; left: 55%; }
.watermark-item:nth-child(39) { top: 75%; left: 75%; }
.watermark-item:nth-child(40) { top: 75%; left: 95%; }
/* 第9行 */
.watermark-item:nth-child(41) { top: 85%; left: 5%; }
.watermark-item:nth-child(42) { top: 85%; left: 25%; }
.watermark-item:nth-child(43) { top: 85%; left: 45%; }
.watermark-item:nth-child(44) { top: 85%; left: 65%; }
.watermark-item:nth-child(45) { top: 85%; left: 85%; }
/* 第10行 */
.watermark-item:nth-child(46) { top: 95%; left: 15%; }
.watermark-item:nth-child(47) { top: 95%; left: 35%; }
.watermark-item:nth-child(48) { top: 95%; left: 55%; }
.watermark-item:nth-child(49) { top: 95%; left: 75%; }
.watermark-item:nth-child(50) { top: 95%; left: 95%; }
</style>



// WEBPACK FOOTER //
// src/components/Watermark.vue